import { TableColumn } from '../../../components/forms/form-entries/form-entry-list/entry-list/dynamic-table/dynamic-table.component';
import { ForkliftInspection } from './forklift-inspection.model';

export class ForkliftInspectionListItem {
  /** When the form was submitted ("Entry Date" column) */
  submissionDate: Date | null = null;

  /** The person who submitted the form ("User" column) */
  submittedByName: string | null = null;

  /** Job name/number */
  jobNameNumber: string | null = null;

  /** Battery inspection result */
  battery: string | null = null;

  /** Battery inspection comments */
  batteryComments: string | null = null;

  /** Bolts and pins inspection result */
  boltsPins: string | null = null;

  id: string = '';
  equipmentNumber: string = '';
  location: string = '';

  constructor(data?: Partial<ForkliftInspectionListItem>) {
    if (data) {
      Object.assign(this, data);
    }
  }

  static getTableColumns(): TableColumn[] {
    const columns: TableColumn[] = [];
    const instance = new ForkliftInspectionListItem();
    const fieldMappings = ForkliftInspection.getFieldMappings();
    
    // Get all properties of the class
    Object.keys(instance).forEach(key => {
      // Skip the id property as it's handled separately
      if (key === 'id') return;

      // Determine the type based on the property value
      let type: 'text' | 'date' | 'action' | 'status' = 'text';
      const value = instance[key as keyof ForkliftInspectionListItem];
      
      if (value instanceof Date || (value === null && key.toLowerCase().includes('date'))) {
        type = 'date';
      }
      // All other values default to 'text' type

      // Add the column if it has a mapping
      if (fieldMappings[key]) {
        columns.push({
          key,
          label: fieldMappings[key],
          type,
          sortable: true
        });
      }
    });

    

    return columns;
  }

  static fromApiResponse(data: any): ForkliftInspectionListItem {
    return new ForkliftInspectionListItem({
      id: data.id,
      submissionDate: data.submissionDate ? new Date(data.submissionDate) : null,
      submittedByName: data.submittedByName,
      jobNameNumber: data.jobNameNumber,
      battery: data.battery,
      batteryComments: data.batteryComments,
      boltsPins: data.boltsPins,
      equipmentNumber: data.equipmentNumber,
      location: data.location
    });
  }
} 